<div
  class="table-container"
  lang="de"
  *ngIf="formGroup"
  [formGroup]="formGroup"
>
  <table class="marschzeit-table excel-header">
    <thead>
      <tr class="header-row-1">
        <th class="label-cell">Route:</th>
        <th colspan="5" class="input-cell">
          <input
            type="text"
            formControlName="route_name"
            class="export-input"
          />
        </th>
        <th class="label-cell" colspan="2" style="border-left: 1px solid #ccc">
          Geschwindigkeitsfaktor (Lkm / h):
        </th>
      </tr>
      <tr class="header-row-2">
        <th class="label-cell">Datum:</th>
        <th class="input-cell" colspan="5">
          <input
            type="datetime-local"
            formControlName="departure_time"
            class="export-input"
          />
        </th>
        <th
          class="input-cell text-center"
          colspan="2"
          style="border-left: 1px solid #ccc"
        >
          <input
            type="number"
            formControlName="velocity"
            step="0.25"
            class="export-input text-center bold-input"
          />
        </th>
      </tr>
      <tr class="header-row-3">
        <th class="label-cell">erstellt von:</th>
        <th colspan="7" class="input-cell">
          <input
            type="text"
            formControlName="creator_name"
            class="export-input"
          />
        </th>
      </tr>
      <tr class="header-row-4">
        <th class="label-cell">Landeskarten:</th>
        <th colspan="7" class="input-cell map-number-cell">
          {{ mapNumbers || "Lade..." }}
        </th>
      </tr>
      <tr class="column-names">
        <th class="col-name">Ort, Flurname, Koordinaten</th>
        <th>Höhe</th>
        <th>hm</th>
        <th>km</th>
        <th>Lkm</th>
        <th>h:mm</th>
        <th>hh:mm</th>
        <th class="col-break">Pausen</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="rows.length === 0">
        <td colspan="8" class="empty-state">
          <h3>Noch keine Route vorhanden</h3>
          <p>
            Zeichne zuerst einen Pfad auf der Karte ein oder importiere eine
            Datei, um eine Marschzeittabelle zu erstellen.
          </p>
        </td>
      </tr>
      <tr
        *ngFor="
          let row of rows;
          let first = first;
          let last = last;
          let i = index;
          trackBy: trackByFn
        "
        [class.row-highlighted]="highlightedRowIndex === i"
        (mouseenter)="onRowHover(row)"
        (mouseleave)="onRowLeave()"
      >
        <td class="col-name">
          <div style="display: flex; align-items: center; width: 100%">
            <input
              type="text"
              [(ngModel)]="row.waypoint.name"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="autoWaypoints"
              placeholder="{{ row.waypoint.x | number: '1.0-0' }}, {{
                row.waypoint.y | number: '1.0-0'
              }}"
              (ngModelChange)="onFieldChange(row)"
            />
            <mat-icon
              *ngIf="!autoWaypoints"
              class="action-icon"
              [class.disabled-icon]="isAutoNamed(row)"
              matTooltip="Automatisch benennen"
              (click)="!isAutoNamed(row) && autoName(row)"
              >auto_awesome</mat-icon
            >
            <mat-icon
              *ngIf="!autoWaypoints && !first && !last"
              class="action-icon delete-icon"
              matTooltip="Wegpunkt löschen"
              (click)="deletePoi(row.waypoint)"
              >delete_outline</mat-icon
            >
          </div>
        </td>
        <td class="text-right" data-label="Höhe">
          {{ row.waypoint.h | number: "1.0-0" }}
        </td>
        <td class="text-right" data-label="hm">
          {{ first ? "" : (row.delta_h | number: "1.0-0") }}
        </td>
        <td class="text-right" data-label="km">
          {{ first ? "" : (row.delta_dist | number: "1.1-1") }}
        </td>
        <td class="text-right sum-col" data-label="Lkm">
          {{ first ? "" : (row.lkm | number: "1.1-1") }}
        </td>
        <td class="text-right" data-label="h:mm">
          {{ first ? "" : formatDuration(row.time_hours) }}
        </td>
        <td class="highlight-col" data-label="hh:mm">
          <span class="time-badge">{{
            row.planned_arrival | date: "HH:mm"
          }}</span>
        </td>
        <td class="col-break" data-label="Pausen">
          <input
            type="number"
            [disabled]="autoWaypoints"
            [(ngModel)]="row.waypoint.break_duration"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Minuten"
            (ngModelChange)="onFieldChange()"
          />
        </td>
      </tr>
    </tbody>
  </table>
</div>
